var _rect, _path, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    rx: 10.5,
    fill: "url(#paint0_linear_1923_42449)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 7.98518V7.986V13.014C16.7 14.0463 16.3933 14.8342 15.8634 15.3638C15.3336 15.8934 14.5452 16.2 13.5122 16.2H8.48774C7.45482 16.2 6.6665 15.8934 6.13667 15.3632C5.60682 14.8329 5.3 14.0435 5.3 13.008V7.986C5.3 6.9537 5.60669 6.16577 6.13654 5.63618C6.66641 5.10658 7.45481 4.8 8.48774 4.8H13.5182C14.5512 4.8 15.3395 5.10661 15.8686 5.63605C16.3975 6.16541 16.7028 6.95307 16.7 7.98518ZM14.6313 7.84904L14.6431 7.83848L14.6536 7.82675C14.7295 7.74245 14.7902 7.64781 14.8337 7.54343C14.8765 7.44074 14.9048 7.32353 14.9048 7.2C14.9048 7.07798 14.8772 6.96214 14.8352 6.86036C14.7885 6.74052 14.7235 6.65084 14.6536 6.57325L14.6372 6.55502L14.6181 6.53969C14.6121 6.53494 14.6086 6.53187 14.6026 6.52668C14.5977 6.52236 14.591 6.51657 14.5799 6.50712C14.5639 6.49352 14.5361 6.47027 14.5019 6.44899C14.4541 6.41758 14.4027 6.39075 14.3478 6.37053C14.294 6.34554 14.2365 6.32698 14.1722 6.31671C13.8789 6.25651 13.5708 6.35728 13.3662 6.56182L13.3606 6.56739L13.3553 6.57326C13.2855 6.65084 13.2205 6.74052 13.1737 6.86036C13.1318 6.96215 13.1042 7.07799 13.1042 7.2L13.1042 7.20333C13.1055 7.32072 13.1299 7.4367 13.1758 7.54469C13.2193 7.64857 13.2797 7.74279 13.3553 7.82674L13.3609 7.83298L13.3669 7.83889C13.4934 7.96449 13.6545 8.04956 13.8295 8.08326C14.0042 8.11691 14.185 8.09787 14.3489 8.02856C14.4529 7.98511 14.5473 7.92467 14.6313 7.84904ZM8.37383 10.5C8.37383 11.9498 9.55281 13.128 11.003 13.128C12.4532 13.128 13.6322 11.9498 13.6322 10.5C13.6322 9.05017 12.4532 7.872 11.003 7.872C9.55281 7.872 8.37383 9.05017 8.37383 10.5Z",
    stroke: "white",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.5,
    width: 12,
    height: 12,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1923_42449",
    x1: 11,
    y1: 0,
    x2: 12.5672,
    y2: 18.3879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5317C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#EF08EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#FD2F57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC005"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.38a2686d1d0070d04f522d5e851e911a.svg";
export { ForwardRef as ReactComponent };